import React from "react"
import classnames from "classnames"
import { Alert } from "AtomicComponents"
import styles from "./AlertList.less"

class AlertList extends React.Component {

  render() {
    const { data } = this.props
    if (!data || data === "" || data === undefined) return ""
    return (
      <div
        className={classnames({
          [styles.AlertList]: true
        })}>

          {!Array.isArray(data) && <Alert>{data}</Alert>}


          {Array.isArray(data) && data.map((item,index)=>{
            return <Alert key={`Alert-${index}`}>{item}</Alert>
          })}
      </div>
    )
  }
}


export default AlertList



// WEBPACK FOOTER //
// ./src/AtomicContainers/AlertList/AlertList.jsx